module.exports = __webpack_public_path__ + "static/media/secure-stripe-payment.35b0c80b.png";